export default __webpack_public_path__ + "static/media/05.a7ab2c82.jpg";